/**
 * Visual config for Auth Issues sources.
 *
 * The source registry itself (key → buildSource → label → description →
 * channel → kind) lives on the backend (`backend/reports/auth_issues/sources.js`)
 * and ships to the frontend in the report response. This file adds the
 * per-source UI color only.
 *
 * `account_revoked` gets a deliberately muted, desaturated color, distinct
 * from the failure palette — it's the one `kind: 'informational'` source
 * (never a stack segment, never part of the failure rate) and its color
 * should read as "different category," not just "another cause."
 */
export const SOURCE_COLORS = {
  login_failure: '#f43f5e',               // rose
  signup_failure: '#ff9f0a',              // orange
  delete_request_failure: '#a78bfa',      // violet
  apple_refresh_token_failure: '#06b6d4', // cyan
  signup_check_failure: '#d946ef',        // fuchsia
  profile_decode_failure: '#fb7185',      // pink
  skier_fetch_failure: '#eab308',         // yellow
  account_revoked: '#6b7280',             // slate — deliberately muted (informational, not a failure)
};

// Login-attempt denominator line. Distinct from every failure color so it
// always reads as the baseline/denominator trace, same role Active Skiers
// plays in Goggles Connectivity.
export const LOGIN_ATTEMPTS_LINE_COLOR = '#38bdf8'; // sky

export const getSourceColor = (key) => SOURCE_COLORS[key] || '#888888';
